/**
 * AxelarHealthMetrics Component
 *
 * Health metrics panel for Axelar network.
 */

import { Icons } from '../Icons';
import { GenericHealthMetrics, networkConfigs } from '../common/GenericHealthMetrics';
import type { AxelarNetworkMetrics } from '../../services/blockchainHealthApi';

const AXL_COLOR = '#00D1FF';

function renderAxelarMetrics(metrics: Record<string, any>) {
  const m = (metrics || {}) as AxelarNetworkMetrics;
  return (
    <>
      {/* Active Validators */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Server size={24} style={{ color: AXL_COLOR, marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: AXL_COLOR }}>
          {m.activeValidators ?? 0}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Validators
        </div>
      </div>

      {/* Supported Chains */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Link size={24} style={{ color: '#7B3FE4', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#7B3FE4' }}>
          {m.supportedChains ?? 0}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Chains
        </div>
      </div>

      {/* Total Staked */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Lock size={24} style={{ color: '#8b5cf6', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#8b5cf6' }}>
          {m.totalStaked ?? '0'}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Staked
        </div>
      </div>

      {/* Total Transfers */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.ArrowLeftRight size={24} style={{ color: '#f59e0b', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#f59e0b' }}>
          {m.totalTransfers ?? '0'}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Transfers
        </div>
      </div>

      {/* Staking APY */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.TrendingUp size={24} style={{ color: '#22c55e', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#22c55e' }}>
          ~{m.stakingAPY ?? 0}%
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Staking APY
        </div>
      </div>
    </>
  );
}

export function AxelarHealthMetrics() {
  const config = {
    ...networkConfigs.axelar,
    renderNetworkMetrics: renderAxelarMetrics,
  };

  return <GenericHealthMetrics config={config} />;
}
